<template>
  <div v-if="!error">
    <v-row no-gutters>
      <v-col cols="12">
        <h2 class="title">Tänään avoinna olevia yrityksiä</h2>
      </v-col>
      <v-col cols="12">
        <v-list>
          <v-list-item
            v-for="(c, i) in companies"
            :key="i"
            :to="`/yritys/${c.id}`"
          >
            <v-list-item-avatar class="d-none d-sm-inline-flex">
              <v-img
                v-if="c.filestackHandle !== 'ef7GrvYSdGRfEOAR3a0u'"
                :src="`https://cdn.filestackcontent.com/${c.filestackHandle}`"
              ></v-img>
              <div
                v-else
                class="green"
                style="height: 100%; width: 100%;"
              ></div>
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title v-text="c.businessName"></v-list-item-title>
              <v-list-item-subtitle v-text="openText(c)"></v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-icon>
              <v-btn
                class="d-none d-sm-inline-flex"
                color="green"
                :to="`/yritys/${c.id}`"
                dark
                large
                >Lue lisää</v-btn
              >
            </v-list-item-icon>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </div>
</template>

<script>
export default {
  name: 'OpenToday',
  data: () => ({
    error: false,
    companies: [],
    loading: true
  }),
  mounted() {
    fetch('https://hallinta.kotona.kiuruvesi.net/fontend/openToday')
      .then(res => res.json())
      .then(res => (this.companies = [...res]))
      .catch(err => (this.error = err))
      .finally(() => (this.loading = false))
  },
  methods: {
    openText(c) {
      // https://stackoverflow.com/a/24481597
      let openToday = c.openHours[(new Date().getDay() + 6) % 7].toLowerCase()
      return openToday === 'suljettu'
        ? 'Tänään suljettu'
        : `Avoinna tänään ${openToday}`
    }
  }
}
</script>
